 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account":"account","adminConsole":"adminConsole","attendance":"attendance","Newsletter Templates~index":"Newsletter Templates~index","index":"index","Newsletter Templates":"Newsletter Templates","Group announcement":"Group announcement","announcements":"announcements","commbook":"commbook","moments":"moments","students":"students","classDetail":"classDetail","classes":"classes","companies":"companies","companyInfo":"companyInfo","companyRoles":"companyRoles","connections":"connections","contacts":"contacts","dashBoard":"dashBoard","editRoles":"editRoles","enrollmentInfo":"enrollmentInfo","forgotPwd":"forgotPwd","general":"general","locations":"locations","login":"login","parentPersonalInfo":"parentPersonalInfo","parents":"parents","parentsDetail":"parentsDetail","parentsInfo":"parentsInfo","personalInfo":"personalInfo","resetPassword":"resetPassword","settingAttendance":"settingAttendance","settingAttendanceInfo":"settingAttendanceInfo","settingClasses":"settingClasses","settingCommbook":"settingCommbook","settingCompanies":"settingCompanies","settingCompanyInfo":"settingCompanyInfo","settingLocationInfo":"settingLocationInfo","settingLocations":"settingLocations","settingMoments":"settingMoments","settingStaff":"settingStaff","settingStudentId":"settingStudentId","settingStudents":"settingStudents","settingUsers":"settingUsers","settings":"settings","staff":"staff","staffInfo":"staffInfo","studentsInfo":"studentsInfo","tablePage~tablePageLocations":"tablePage~tablePageLocations","tablePage":"tablePage","tablePageLocations":"tablePageLocations","teachers":"teachers","userRoles":"userRoles","users":"users","usersInfo":"usersInfo"}[chunkId]||chunkId) + "." + {"account":"14f7cdcd","adminConsole":"b531e4ad","attendance":"2d98591b","chunk-0dcd4440":"4f4f57a4","Newsletter Templates~index":"a0c5add9","index":"217b45f6","chunk-44b225ea":"177c4d5e","Newsletter Templates":"b645f966","chunk-500b4f29":"5e678e58","chunk-f6cbb1f4":"ace8d961","Group announcement":"50efb3b5","announcements":"09b09ae2","commbook":"bd574ed5","moments":"0af140a4","chunk-37a346c4":"41b3d561","chunk-4185dec9":"7de3f270","chunk-6d304aa6":"53dbd2b1","students":"89ba9646","classDetail":"94bbec15","classes":"9de41a60","companies":"bb34729b","companyInfo":"bc0aa1e0","companyRoles":"c89fd76f","connections":"ffbbbf73","contacts":"8bd5a093","dashBoard":"16809099","editRoles":"d4866206","enrollmentInfo":"3819bec7","forgotPwd":"449c5622","general":"72fef210","locations":"b68ce5b3","login":"018eafad","parentPersonalInfo":"19da9b3c","parents":"154ed331","parentsDetail":"b5dbff7b","parentsInfo":"0a6906f4","personalInfo":"10f5328d","resetPassword":"ee458052","settingAttendance":"d619d4ad","settingAttendanceInfo":"cc8d0e1d","settingClasses":"72cba354","settingCommbook":"9ff88831","settingCompanies":"1ecf4e17","settingCompanyInfo":"c34a5796","settingLocationInfo":"385516e5","settingLocations":"2afb9cc0","settingMoments":"29ee6b97","settingStaff":"ba6b4e4d","settingStudentId":"72a45d25","settingStudents":"3d968a77","settingUsers":"3a7fb738","settings":"4e0f36dc","staff":"11282855","staffInfo":"f4d92571","studentsInfo":"85b4b156","tablePage~tablePageLocations":"3d8ffba0","tablePage":"fac2d0b1","tablePageLocations":"3eeaf29f","teachers":"1c041813","userRoles":"41672149","users":"e98d4779","usersInfo":"4cefab58","chunk-2d216214":"1f54003d","chunk-2d216257":"58872a85","chunk-f161720c":"882290f7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account":1,"adminConsole":1,"attendance":1,"Newsletter Templates~index":1,"index":1,"Newsletter Templates":1,"Group announcement":1,"announcements":1,"commbook":1,"moments":1,"chunk-37a346c4":1,"chunk-4185dec9":1,"chunk-6d304aa6":1,"students":1,"classDetail":1,"classes":1,"companies":1,"companyInfo":1,"companyRoles":1,"connections":1,"contacts":1,"editRoles":1,"enrollmentInfo":1,"forgotPwd":1,"general":1,"locations":1,"login":1,"parentPersonalInfo":1,"parents":1,"parentsDetail":1,"parentsInfo":1,"personalInfo":1,"resetPassword":1,"settingAttendance":1,"settingAttendanceInfo":1,"settingClasses":1,"settingCommbook":1,"settingCompanies":1,"settingCompanyInfo":1,"settingLocationInfo":1,"settingLocations":1,"settingMoments":1,"settingStaff":1,"settingStudentId":1,"settingStudents":1,"settingUsers":1,"settings":1,"staff":1,"staffInfo":1,"studentsInfo":1,"tablePage":1,"tablePageLocations":1,"teachers":1,"userRoles":1,"users":1,"usersInfo":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account":"account","adminConsole":"adminConsole","attendance":"attendance","Newsletter Templates~index":"Newsletter Templates~index","index":"index","Newsletter Templates":"Newsletter Templates","Group announcement":"Group announcement","announcements":"announcements","commbook":"commbook","moments":"moments","students":"students","classDetail":"classDetail","classes":"classes","companies":"companies","companyInfo":"companyInfo","companyRoles":"companyRoles","connections":"connections","contacts":"contacts","dashBoard":"dashBoard","editRoles":"editRoles","enrollmentInfo":"enrollmentInfo","forgotPwd":"forgotPwd","general":"general","locations":"locations","login":"login","parentPersonalInfo":"parentPersonalInfo","parents":"parents","parentsDetail":"parentsDetail","parentsInfo":"parentsInfo","personalInfo":"personalInfo","resetPassword":"resetPassword","settingAttendance":"settingAttendance","settingAttendanceInfo":"settingAttendanceInfo","settingClasses":"settingClasses","settingCommbook":"settingCommbook","settingCompanies":"settingCompanies","settingCompanyInfo":"settingCompanyInfo","settingLocationInfo":"settingLocationInfo","settingLocations":"settingLocations","settingMoments":"settingMoments","settingStaff":"settingStaff","settingStudentId":"settingStudentId","settingStudents":"settingStudents","settingUsers":"settingUsers","settings":"settings","staff":"staff","staffInfo":"staffInfo","studentsInfo":"studentsInfo","tablePage~tablePageLocations":"tablePage~tablePageLocations","tablePage":"tablePage","tablePageLocations":"tablePageLocations","teachers":"teachers","userRoles":"userRoles","users":"users","usersInfo":"usersInfo"}[chunkId]||chunkId) + "." + {"account":"3c9486e2","adminConsole":"0e433876","attendance":"19905257","chunk-0dcd4440":"31d6cfe0","Newsletter Templates~index":"2f64e12f","index":"e939777e","chunk-44b225ea":"31d6cfe0","Newsletter Templates":"6cb82d5e","chunk-500b4f29":"31d6cfe0","chunk-f6cbb1f4":"31d6cfe0","Group announcement":"477d2b13","announcements":"7db01429","commbook":"8020aad9","moments":"6a96168e","chunk-37a346c4":"7296b501","chunk-4185dec9":"70cca4cc","chunk-6d304aa6":"95b8df92","students":"59e18a86","classDetail":"4e5f7a8b","classes":"4b3d300d","companies":"0e433876","companyInfo":"3e4b6b40","companyRoles":"561d04cc","connections":"5cb3df18","contacts":"87ebdb43","dashBoard":"31d6cfe0","editRoles":"d5b49447","enrollmentInfo":"9b9fc9c8","forgotPwd":"bb160d0c","general":"f1a60e46","locations":"0e433876","login":"a771c41b","parentPersonalInfo":"64343cce","parents":"80295776","parentsDetail":"0e433876","parentsInfo":"017bbc94","personalInfo":"d7308619","resetPassword":"b25098b7","settingAttendance":"0e433876","settingAttendanceInfo":"0e433876","settingClasses":"0e433876","settingCommbook":"0e433876","settingCompanies":"0e433876","settingCompanyInfo":"5a4cd59a","settingLocationInfo":"1ab2635d","settingLocations":"f4614ace","settingMoments":"0e433876","settingStaff":"0e433876","settingStudentId":"e5de7ab5","settingStudents":"0e433876","settingUsers":"0e433876","settings":"0e433876","staff":"d3bc07ff","staffInfo":"a09da281","studentsInfo":"8a071d90","tablePage~tablePageLocations":"31d6cfe0","tablePage":"c114cae4","tablePageLocations":"3dac646f","teachers":"38a80b62","userRoles":"4f3e6743","users":"df682fcc","usersInfo":"55178b77","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-f161720c":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
